export default __webpack_public_path__ + "static/media/disabled-concern-icon.9afbafef.svg";